const radii = {
  big: '24px',
  medium: '16px',
  small: '8px',
}

export default radii
